export default defineNuxtRouteMiddleware((to) => {
  const { loggedIn } = useUserSession()

  if (loggedIn.value) {
    // '/dashboard', bukan '/': di salestial.iziapp.id root adalah landing page
    // statis di luar app (lihat komentar di composables/useTujuanLogin.ts).
    return navigateTo(tujuanLogin(to.query.redirect))
  }
})
